export default __webpack_public_path__ + "static/focus-7b29f929cbe6daf7ffd0560bc28a9a1a.png";